export const en = {
    'strategy-description-avg-click': 'You will get maximum clicks within your set limits',
    'strategy-description-avg-cpa': 'You will maximize conversions using the goal set in Yandex.Metrica',
    'strategy-description-default':
        'You will maximize possible impressions by independently setting bid limits, display region, and other parameters that affect impressions',
    'strategy-description-roi':
        'You will maximize conversions using the goal set in Yandex.Metrica while keeping your ROI at the set level',
    'strategy-name-avg-click': 'Click optimization',
    'strategy-name-avg-cpa': 'Conversion optimization',
    'strategy-name-default': 'Manual bid management with optimization',
    'strategy-name-roi': 'Optimize ROI'
};
